<div class="cart-item-container">
  <h4>{{ item.product.name }}</h4>

  <div *ngFor="let bookingItem of bookingItems">
    <div *ngIf="bookingItem.pendingBookings.length; else noBooking">
      <vnm-flex-container class="align-items-center my-5">
        <div *ngFor="let pendingIlBooking of bookingItem.pendingBookings">
          <div>
            <i>{{ pendingIlBooking.startsAt | date: 'medium' }}</i>
          </div>
          <div>
            <i>{{ pendingIlBooking.timeZone }}</i>
          </div>
        </div>

        <vnm-sidebar-toggle
          label="checkout-booking.change"
          label="checkout-booking.change"
          icon="fa fa-fw fa-pencil"
          flex-end
        >
          <ng-template #toggle>
            <vnm-checkout-bookable-class-list
              [item]="item"
              [ilCourseId]="bookingItem.ilCourse.id"
              (selectedClass)="onSelectClass({ courseItem: bookingItem.courseItem, ilClass: $event })"
            ></vnm-checkout-bookable-class-list>
          </ng-template>
        </vnm-sidebar-toggle>
      </vnm-flex-container>
    </div>

    <ng-template #noBooking>
      <vnm-flex-container class="align-items-center my-5">
        <div>
          <div translate [translateParams]="{ name: bookingItem.courseItem.name }" class="please-book">
            checkout-booking.please-book
          </div>

          <div *ngIf="bookingItem.bookingRequired" class="required-booking" translate>
            checkout-booking-cart-item.required-booking
          </div>
        </div>

        <vnm-sidebar-toggle
          label="checkout-booking-cart-item.book-now"
          icon="fa fa-fw fa-plus"
          buttonClass="p-button-secondary"
          flex-end
        >
          <ng-template #toggle>
            <vnm-checkout-bookable-class-list
              [item]="item"
              [ilCourseId]="bookingItem.ilCourse.id"
              (selectedClass)="onSelectClass({ courseItem: bookingItem.courseItem, ilClass: $event })"
            ></vnm-checkout-bookable-class-list>
          </ng-template>
        </vnm-sidebar-toggle>
      </vnm-flex-container>
    </ng-template>
  </div>
</div>
